import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getAddressLists = (params, callback) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getAddressListsUrl}`).then((response) => {
        callback && callback(response, response);
      });
    } catch (error) {
      console.log("get address lists api err:", error);
      throw error;
    }
  };
};
export const addAddressApi = (data, callback) => {
  return async () => {
    try {
      const response = await apiPost(
        `${ApiConstants.createAddressListUrl}`,
        data
      );
      callback && callback(response, response?.data);
    } catch (error) {
      console.log("add address api err:", error);
      throw error;
    }
  };
};

export const updateAddressApi = (data, callback) => {
  return async () => {
    try {
      const response = await apiPut(
        `${ApiConstants.updateAddressListUrl}`,
        data
      );
      callback && callback(response, response?.data);
    } catch (error) {
      console.log("update address api err:", error);
      throw error;
    }
  };
};

export const deleteAddressApi = (data, callback) => {
  return async () => {
    try {
      const response = await apiDelete(
        `${ApiConstants.deleteAddressListUrl}?user_address_id=${data}`
      );
      callback && callback(response, response?.data);
    } catch (error) {
      console.log("delete address api err:", error);
      throw error;
    }
  };
};

export const getUserAddressByIdAPI = (userAddressId, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.getUserAddressByIdUrl}?user_address_id=${userAddressId}`
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const getUserAddressTypeAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.getUserAddressTypeUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const updateSetAsDefaultAddressAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.updateDefaultAddressUrl, data).then(
        (response) => {
          callBack && callBack(response?.data, response?.data);
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};
